import React, { useState } from 'react';
import Button from '../Button';
import { SHIPMENT_STATUSES } from '../../constants/shipments';
import Dialog from './Dialog';
import { SelectField, TextAreaField, TextField } from './FormFields';
import { Banner } from './Ui';

// Manual status override: a note is required so the history says why; the status is then locked against the sync.
const StatusChangeDialog = ({ current, onClose, onSubmit }) => {
  const [status, setStatus] = useState(SHIPMENT_STATUSES.find((s) => s.value !== current)?.value || 'odeslano');
  const [note, setNote] = useState('');
  const [when, setWhen] = useState('');
  const [noteError, setNoteError] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!note.trim()) { setNoteError('Napište důvod ruční změny stavu.'); return; }
    setNoteError('');
    setBusy(true);
    setError('');
    try {
      const body = { status, note: note.trim() };
      if (when) body.occurredAt = new Date(when).toISOString();
      await onSubmit(body);
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  };

  return (
    <Dialog
      title="Změnit stav zásilky" busy={busy} onClose={onClose}
      footer={(
        <>
          <Button variant="secondary" onClick={onClose} disabled={busy}>Zrušit</Button>
          <Button type="submit" form="shp-status-form" loading={busy}>Změnit stav</Button>
        </>
      )}
    >
      <form id="shp-status-form" onSubmit={submit} noValidate className="shp-stack" style={{ paddingBottom: 8 }}>
        <Banner tone="info">Ruční změna stav zamkne. Synchronizace s Gmailem ho už sama nepřepíše, odemknout ho můžete v detailu.</Banner>
        {error && <Banner tone="bad">{error}</Banner>}
        <SelectField label="Nový stav" required value={status} onChange={(e) => setStatus(e.target.value)} options={SHIPMENT_STATUSES.map((s) => ({ value: s.value, label: s.label }))} />
        <TextAreaField label="Poznámka (důvod změny)" required rows={3} maxLength={1000} value={note} error={noteError} onChange={(e) => { setNote(e.target.value); if (noteError) setNoteError(''); }} />
        <TextField label="Kdy se to stalo" type="datetime-local" value={when} onChange={(e) => setWhen(e.target.value)} hint="Nepovinné. Bez údaje se použije aktuální čas." />
      </form>
    </Dialog>
  );
};

export default StatusChangeDialog;
